import React from "react";

export default function Web_ES5() {
  return (
    <div>
      <h1>What is ES5</h1>
      <p>
        Route: <code>/web/es5</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
